import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex flex-col">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20aerial%20flat%20lay%20of%20diverse%20contemporary%20fashion%20items%20including%20colorful%20sneakers%20in%20coral%20and%20teal%20tones%2C%20folded%20textured%20sweaters%2C%20denim%20jacket%20with%20visible%20stitching%2C%20leather%20accessories%20and%20minimalist%20jewelry%20scattered%20across%20warm%20terracotta%20surface%2C%20dramatic%20side%20lighting%20from%20left%20window%2C%20editorial%20lifestyle%20photography%20with%20intentional%20negative%20space%2C%20rich%20earth%20tones%20with%20olive%20green%20and%20rust%20accents%2C%20organic%20curated%20composition&width=1600&height=900&seq=hero-main-2026-jun&orientation=landscape"
          alt="Mulebuy spreadsheet product collection"
          className="w-full h-full object-cover object-top"
          title="Mulebuy Spreadsheet Product Collection"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center flex-1 w-full px-4 md:px-6 pt-20 pb-12">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-5">
            Mulebuy Spreadsheet
            <br />
            <span className="text-white/90 font-light">Guide &amp; Resource Hub</span>
          </h1>

          <p className="text-base md:text-lg text-white/75 max-w-2xl mx-auto mb-8 leading-relaxed">
            Learn how the mulebuy spreadsheet system works, compare tools, and discover safe, efficient ways to shop using mulebuy spreadsheet platforms. Your complete resource for smarter global shopping.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 w-full">
            <a
              href={siteConfig.mainSite}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white rounded-md font-semibold text-base hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer text-center"
            >
              Mulebuy Spreadsheet
            </a>
            <a
              href={siteConfig.mainSite}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-md font-semibold text-base hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer text-center"
            >
              Buy It Now
            </a>
          </div>

          <Link
            to="/mulebuy-spreadsheet-complete-guide"
            className="inline-block mt-6 text-sm text-white/60 hover:text-white/90 transition-colors underline underline-offset-4 cursor-pointer"
          >
            Read the Complete Mulebuy Spreadsheet Guide
          </Link>
        </div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pb-10 md:pb-14">
        <div className="max-w-6xl mx-auto">
          <div className="rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Horizontal%20product%20showcase%20with%20modern%20fashion%20and%20lifestyle%20items%20arranged%20on%20warm%20honey%20wooden%20shelves%2C%20colorful%20backpacks%20hanging%20neatly%2C%20folded%20sweaters%20in%20mustard%20and%20olive%2C%20white%20sneakers%20displayed%20below%2C%20small%20potted%20plants%20as%20decor%2C%20soft%20warm%20overhead%20lighting%20from%20track%20lights%2C%20boutique%20retail%20display%20aesthetic%2C%20clean%20commercial%20photography%20with%20pleasant%20atmosphere&width=1400&height=500&seq=hero-bottom-2026-jun&orientation=landscape"
              alt="Mulebuy spreadsheet product categories showcase"
              className="w-full h-auto object-cover"
              title="Mulebuy Spreadsheet Categories"
            />
          </div>
        </div>
      </div>
    </section>
  );
}